export default {
  zh: {
    editCol: '编辑列',
    ResetDefault: '恢复默认设置',
    ResetDefaultHint: '恢复至初始设置。',
    maxRowsError: '选择字段不能超过15个',
  },
  en: {
    editCol: 'Edit Column',
    ResetDefault: 'Restore Defaults',
    ResetDefaultHint: 'To restore to its default header.',
    maxRowsError: 'The limit of selected fields is 15.',
  },
};



// WEBPACK FOOTER //
// ./src/components/page/FieldFilterModal/i18n.js